import React from 'react';
import PropTypes from 'prop-types';
import Sidebar from '../Sidebar';
import WidgetPanel from '../WidgetPanel';
import ToolBar from '../ToolBar';
import styles from './MainUI.module.scss';
import { connect } from 'dva';

function MainUI(props) {
  return (
    <div className={styles.container}>
      <ToolBar />
      <Sidebar />
      { props.mapRef ? <WidgetPanel /> : null}
    </div>
  );
}

MainUI.propTypes = {
  mapRef: PropTypes.any,
};

export default connect((model) => {
  return {
    mapRef: model.map.mapRef
  };
})(MainUI);
